export default "__VITE_ASSET__DoQYyXd5__"